import { isEthereumWallet } from "@dynamic-labs/ethereum";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useQuery } from "@tanstack/react-query";
import { type WalletClient } from "viem";

import { isChainSupported } from "#/utils/isChainSupported";

export const useWalletClient = () => {
  const { primaryWallet, network } = useDynamicContext();

  const {
    data: walletClient,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["getWalletClient", primaryWallet?.address, network?.toString()],
    enabled: Boolean(
      primaryWallet && isEthereumWallet(primaryWallet) && Boolean(network),
    ),
    queryFn: async () => {
      if (!isEthereumWallet(primaryWallet!)) return null;

      if (!network || !isChainSupported(Number(network))) return null;

      return (await primaryWallet!.getWalletClient(
        network?.toString(),
      )) as WalletClient;
    },
  });

  return {
    walletClient,
    isLoading,
    refetch,
  };
};
